module.exports = __webpack_public_path__ + "static/media/favourite-brand-bg-sm.9ea4f4e7.png";